import { MenuT } from 'types/frontend/Menu';

// 나중에 다국어 함수로 대체
const t = (str: string) => str;

const etcRootPath = '/etc';

const etcMenu: MenuT = [
  {
    title: t('테스트'),
    items: [
      // {
      //   title: t('학생별 기본 청구 항목'),
      //   path: `${billMenuRootPath}/guide`,
      // },
      {
        title: t('mobx 테스트'),
        path: `${etcRootPath}/group/add`,
      },
    ],
  },
];

export { etcMenu };
